// extracted by mini-css-extract-plugin
export default {"col_dark":"Typography_col_dark__lbn8I","col_light":"Typography_col_light__bL0dO","col_highlighted":"Typography_col_highlighted__LqR4W","heading":"Typography_heading__RC79S"};